export const microHardnessTemplate = [
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.document_version',
  },
  {
    header: 'generateReport.dataToResult.report.test.micro_hardness.id_ensaio',
  },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.product' },
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.product_version',
  },
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.date_authorised',
  },
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.observacao_geral',
  },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.project' },
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.planta_origem',
  },
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.data_cadastro',
  },
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.data_liberacao_resultado',
  },
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.amostra_mes',
  },
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.desc_cliente',
  },
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.descricao_mes',
  },
  {
    header: 'generateReport.dataToResult.report.test.micro_hardness.firma_insp',
  },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.pedido' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.item' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.corrida' },
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.ordem_de_processo',
  },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.lote_tt' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.ippn' },
  {
    header:
      'generateReport.dataToResult.report.test.micro_hardness.posicao_amostra',
  },
  {
    header: 'generateReport.dataToResult.report.test.micro_hardness.id_amostra',
  },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q1_1' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q1_2' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q1_3' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q1_4' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q1_5' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q1_med' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q2_1' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q2_2' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q2_3' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q2_4' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q2_5' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.q2_med' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.dur_min' },
  { header: 'generateReport.dataToResult.report.test.micro_hardness.dur_max' },
  {
    header: 'generateReport.dataToResult.report.test.micro_hardness.media_min',
  },
  {
    header: 'generateReport.dataToResult.report.test.micro_hardness.media_max',
  },
]
